
export enum WarningLevel {
    Unknown = 0,
    Low = 1, 
    Medium = 2, 
    High = 3
}